import React from "react";

// Function to format date as "DD.MM.YYYY"
const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0"); // Ensures two digits for day
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Ensures two digits for month (months are 0-based)
  const year = date.getFullYear();
  return `${day}.${month}.${year}`; // Returns date in the format: "03.01.2025"
};

const FeaturedPosts = ({ posts }) => {
  return (
    <div className="container mx-auto px-20 py-8">
      <div className="flex flex-wrap -mx-4">
        <div className="w-full">
          <h4 className="text-2xl font-semibold text-gray-800 mb-4">
            Featured
          </h4>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 w-full">
          {posts.map((post, index) => (
            <div
              key={index}
              className="bg-white shadow-lg rounded-lg overflow-hidden transform transition duration-300 hover:scale-105 hover:shadow-2xl"
            >
              <a href={post.link} title={post.title}>
                <img
                  className="w-full h-auto object-cover transition duration-300 transform hover:scale-105"
                  src={
                    post.featuredImage
                      ? `${process.env.REACT_APP_DO_SPACES_URL}${post.featuredImage}`
                      : "/placeholder.jpg" // Fallback image
                  }
                  alt={post.title}
                />
              </a>
              <div className="p-4">
                <div className="text-gray-500 text-sm flex items-center space-x-2">
                  <span>{post?.author || "Unknown Author"}</span>
                  <span>-</span>
                  <span>
                    {formatDate(post?.date) || "No date available"}
                  </span>{" "}
                  {/* Formatted date */}
                  <span>-</span>
                  <span>{post?.readMins || "N/A"} mins read</span>{" "}
                  {/* Read time in minutes */}
                </div>
                <h3 className="text-xl font-semibold text-gray-800 mb-2">
                  <a
                    href={post.link}
                    title={post.title}
                    className="hover:text-blue-500"
                  >
                    {post.title}
                  </a>
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FeaturedPosts;
